'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _slide = require('react-burger-menu/lib/menus/slide');

var _slide2 = _interopRequireDefault(_slide);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _App = require('./App.css');

var _App2 = _interopRequireDefault(_App);

var _iyvSocialShare = require('../../../static/images/iyv-social-share.jpg');

var _iyvSocialShare2 = _interopRequireDefault(_iyvSocialShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return _promise2.default.resolve();
  }
}]), _dec2 = (0, _reactCssModules2.default)(_App2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this.clickMenu = function () {
      _this.setState({ menuOpen: !_this.state.menuOpen });
    };

    _this.renderDebug = function () {
      // console.log('this.state:',this.state.debug )
      if (!_this.state.debug) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'debug-device' },
        _react2.default.createElement(
          'div',
          { styleName: 'visible-xs' },
          ' XS - mobile '
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-sm' },
          ' SM - tablet '
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-md' },
          ' MD - desktop '
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-lg' },
          ' LG - large desktop '
        )
      );
    };

    _this.state = {
      menuOpen: false,
      debug: props.location.query.debug
    };
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      var styles = {
        bmBurgerButton: {
          position: 'relative',
          // width: '1.25rem',
          // height: '1.1rem',
          float: 'right',
          cursor: 'pointer'
        },
        bmBurgerBars: {
          background: '#333',
          cursor: 'pointer'
        },
        bmIcon: {
          whiteSpace: 'nowrap',
          fontSize: '1.5em',
          fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        bmMenuWrap: {
          top: 0,
          zIndex: 10001,
          width: '80%',
          maxWidth: '80%'
        },
        bmCrossButton: {
          height: '1.6rem',
          width: '1.6rem',
          cursor: 'pointer'
        },
        bmCross: {
          background: '#333',
          cursor: 'pointer'
        },
        bmMenu: {
          background: 'white',
          padding: '0 2.5rem 0 0',
          fontSize: '1.15rem',
          top: 0,
          borderLeft: '1px solid #A3A3A3'
        },
        bmMorphShape: {
          fill: 'white'
        },
        bmItemList: {
          color: '#333',
          padding: '0 1rem 1rem 1rem',
          boxSizing: 'border-box'
        },
        bmOverlay: {
          background: 'rgba(0, 0, 0, 0.76)',
          top: 0,
          left: 0,
          zIndex: 10000
        }
      };

      _config2.default.app.head.meta = _config2.default.app.head.meta.map(function (meta) {
        // since config.js doesnt have access to import, we will inject the image path here
        // after a replacement of the absolute url with
        if (meta.property === 'og:image' || meta.property === 'twitter:image') {
          meta.content = _config2.default.domain + _iyvSocialShare2.default.replace(/.*dist/, '/dist');
        }
        return meta;
      });

      var iyvLogo = require('../../../static/images/iyv-logo-sm.png');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement('div', { id: 'anchor-top' }),
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          'div',
          { styleName: 'header-container-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'header-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'header-container-inner' },
              this.renderDebug(),
              _react2.default.createElement(
                'div',
                { styleName: 'header-title' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.home,
                    title: 'Invest Your Values'
                  },
                  _react2.default.createElement('img', {
                    src: iyvLogo,
                    styleName: 'header-title-img',
                    alt: 'Invest Your Values'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hidden-xs donate-btn-wrap' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.donate,
                    title: 'Donate to As You Sow',
                    headerdonatebutton: true
                  },
                  'Donate'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'menu-wrap' },
                _react2.default.createElement(
                  _slide2.default,
                  {
                    styles: styles,
                    isOpen: this.state.menuOpen,
                    burgerButtonClassName: '',
                    customBurgerIcon: _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'div',
                        { style: { fontSize: '0.75em' } },
                        'Menu'
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        '\xA0\xA0',
                        _react2.default.createElement('i', { className: 'fa fa-bars' })
                      )
                    ),
                    right: true
                  },
                  _react2.default.createElement(
                    'nav',
                    null,
                    _react2.default.createElement(
                      _reactFlexboxGrid.Row,
                      null,
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { xs: 12, md: 4, styleName: 'menu-column' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.home,
                              title: 'Home'
                            },
                            'Home'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.issues,
                              title: 'The issues'
                            },
                            'The issues'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-sublabel' },
                            'Environment'
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueFossilFuels,
                                title: 'The issues: Fossil fuels'
                              },
                              'Fossil fuels'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueFossilFuelFinanceInsurance,
                                title: 'The issues: Fossil fuel finance & insurance'
                              },
                              'Fossil fuel finance & insurance'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueDeforestation,
                                title: 'The issues: Deforestation'
                              },
                              'Deforestation'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-sublabel' },
                            'Social'
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueGenderEquality,
                                title: 'The issues: Gender equality'
                              },
                              'Gender equality'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueCivilianFirearms,
                                title: 'The issues: Civilian firearms'
                              },
                              'Civilian firearms'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issuePrisonIndustrialComplex,
                                title: 'The issues: Prison industrial complex'
                              },
                              'Prison industrial complex'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueArmsManufacturers,
                                title: 'The issues: Arms manufacturers'
                              },
                              'Arms manufacturers'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.issueTobacco,
                                title: 'The issues: Tobacco'
                              },
                              'Tobacco'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { xs: 12, md: 4, styleName: 'menu-column' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.solutions,
                              title: 'The solutions'
                            },
                            'The solutions'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.solutionOfferSustainability,
                                title: 'Offer sustainable investments'
                              },
                              'Offer sustainable investments'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.solutionDefaultSustainability,
                                title: 'Make the default investment sustainable'
                              },
                              'Make the default investment sustainable'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.data,
                              title: 'The data'
                            },
                            'The data'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.plans,
                                title: 'The data: Retirement plans'
                              },
                              'Retirement plans'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.targetDateFunds,
                                title: 'The data: Target date funds'
                              },
                              'Target date funds'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.mutualFundsETFs,
                                title: 'The data: Mutual funds & ETFs'
                              },
                              'Mutual funds & ETFs'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.assetManagers,
                                title: 'The data: Asset managers'
                              },
                              'Asset managers'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.companies,
                                title: 'The data: Publicly-traded companies'
                              },
                              'Publicly-traded companies'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.fossilFuelBondsIn401ks,
                                title: 'The data: Fossil fuel bonds in 401(k)s'
                              },
                              'Fossil fuel bonds in 401(k)s'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.howitworks,
                                title: 'The data: Methodology'
                              },
                              'Methodology'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { xs: 12, md: 4, styleName: 'menu-column' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.eduCenter,
                              title: 'Action center'
                            },
                            'Action center'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.eduCenterIndividual,
                                title: 'For employees'
                              },
                              'For employees'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.eduCenterPlanAdmins,
                                title: 'For plan administrators'
                              },
                              'For plan administrators'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.eduCenterFinRisks,
                                title: 'Financial risks of unsustainable investments'
                              },
                              'Financial risks of unsustainable investments'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.fossilFuelBondRisks,
                                title: 'Financial risks of fossil fuel bonds'
                              },
                              'Financial risks of fossil fuel bonds'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'menu-link-alt' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: _config2.default.routes.faqs,
                                title: 'FAQs'
                              },
                              'FAQs'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.about,
                              title: 'About us'
                            },
                            'About us'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link-alt' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.links.contact,
                              title: 'Contact us'
                            },
                            'Contact us'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link-alt' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.routes.legal,
                              title: 'Legal disclaimer'
                            },
                            'Legal disclaimer'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'menu-link' },
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.links.signup,
                              title: 'Sign up for email updates'
                            },
                            'Sign up for email updates'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            _components.Link,
                            {
                              to: _config2.default.links.donate,
                              title: 'Donate to As You Sow',
                              headerdonatebutton: true
                            },
                            'Donate'
                          )
                        ),
                        _react2.default.createElement('br', null)
                      )
                    )
                  ),
                  _react2.default.createElement(_components.IyvBanner, { hideTagline: true, hideLink: true })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'content' },
          this.props.children
        ),
        _react2.default.createElement(_components.AppFooter, { hideSiteMap: true }),
        _react2.default.createElement(_components.AppDisclaimer, null)
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1461
// module chunks = 0